import { useState } from "react";
import { TeamType } from "../../components/Type/TeamType";

export type BattleTeamType = {
    attack: TeamType | null,
    defence: TeamType | null,
    updateAttackTeam: (attack: TeamType) => void,
    updateDefenceTeam: (defence: TeamType) => void
};

export const useBattleTeamProvide = (): BattleTeamType => {
    const [attack, setAttackTeam] = useState<TeamType | null>(null);
    const [defence, setDefenceTeam] = useState<TeamType | null>(null);
    const updateAttackTeam = (attack: TeamType) => {
        setAttackTeam(attack)
    }
    const updateDefenceTeam = (defence: TeamType) => {
        setDefenceTeam(defence)
    }
    return { attack, defence, updateAttackTeam, updateDefenceTeam };
};
